import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { LucideIcon } from "lucide-react";

interface StatCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  trend?: string;
  trendUp?: boolean;
  className?: string;
  iconClassName?: string;
}

export function StatCard({ 
  title, 
  value, 
  icon: Icon, 
  trend, 
  trendUp, 
  className,
  iconClassName 
}: StatCardProps) {
  return (
    <Card className={cn("hover-card-effect p-6", className)}>
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm font-medium text-muted-foreground">{title}</p>
          <h3 className="text-2xl font-bold mt-2 font-display">{value}</h3>
          {trend && (
            <p className={cn(
              "text-xs mt-1 font-medium flex items-center gap-1",
              trendUp ? "text-green-600" : "text-red-600"
            )}>
              {trendUp ? "+" : ""}{trend}
            </p>
          )}
        </div>
        <div className={cn("p-3 rounded-xl bg-primary/10 text-primary", iconClassName)}>
          <Icon className="w-5 h-5" />
        </div>
      </div>
    </Card>
  );
}
